const MOBILE_BREAKPOINT = 767;

// eslint-disable-next-line complexity

function addCarousel() {
  const slickMain = document.querySelector('.slick-main');

  if (document.body.clientWidth < MOBILE_BREAKPOINT && slickMain && slickMain.classList.contains('myslider-mob')) {
    $('.myslider-mob').slick({
      centerMode: true,
      variableWidth: false,
      variableHeight: true,
      centerPadding: '0px',
      arrows: false,
      dots: true,
      respondTo: 'myslider-mob',
      mobileFirst: true,
      infinite: true,
      swipe: true,
    });
  }
}

function removeCarousel() {
  $('.myslider-mob').slick('unslick');
}

function handleMobileBreakpoint(e) {
  if (e.matches) {
    addCarousel();
  } else {
    removeCarousel();
  }
}

function onContentLoaded() {
  const mediaQueryMobile = window.matchMedia(`(max-width: ${MOBILE_BREAKPOINT}px)`);

  mediaQueryMobile.addEventListener('change', handleMobileBreakpoint);
  handleMobileBreakpoint(mediaQueryMobile);
}

document.addEventListener('DOMContentLoaded', onContentLoaded);

const quantityHandler = (event) => {
  const quantityIncreaseButton = event.target;
  const quickReorderAction = quantityIncreaseButton.getAttribute('data-action');
  let quickReorderQuantity = Number(quantityIncreaseButton.parentNode.querySelector('.pdp-modal-quantity').value);
  let staticReorderPrice;

  staticReorderPrice = quantityIncreaseButton.closest('.quick-reorder-product-popup-content').querySelector('.quick-reorder-product-price .reorder-total-price').dataset.itemPrice;

  if (staticReorderPrice) {
    staticReorderPrice = staticReorderPrice.replace('$', '');
  }

  if (quickReorderQuantity && staticReorderPrice) {
    const quantityArrows = quantityIncreaseButton.closest('.quick-reorder-product-popup-quantity').querySelector('.bottom-arrow');

    if (quickReorderAction === 'decrease') {
      if (quickReorderQuantity > 1) {
        quickReorderQuantity -= 1;
      } else if (quickReorderQuantity === 1) {
        quantityArrows.style.opacity = '0.5';
      }
    } else {
      quickReorderQuantity += 1;
      quantityArrows.style.opacity = '1';
    }

    const quickReorderPriceValue = quickReorderQuantity * staticReorderPrice;
    const popupContent = quantityIncreaseButton.closest('.quick-reorder-product-popup-content');
    const totalPrice = popupContent.querySelector('.quick-reorder-product-price .reorder-total-price');
    const quantity = quantityIncreaseButton.closest('.quick-reorder-product-popup-quantity').querySelector('.pdp-modal-quantity');

    totalPrice.textContent = quickReorderPriceValue.toFixed(2);
    quantity.value = quickReorderQuantity;
  }

  const quickStaticItem = quantityIncreaseButton.closest('.quick-reorder-product-popup-content').querySelector('.quick-reorder__product-order button.reorder-quantity-holder');

  const quantityaddtocart = quantityIncreaseButton.closest('.quick-reorder-product-popup-content').querySelector('.quick-reorder__product-order .quick-reorder-button');

  if (quickStaticItem && quickStaticItem.getAttribute('href')) {
    const quickStaticHref = quickStaticItem.getAttribute('href').split(':');

    if (quickStaticHref.length > 0) {
      const quickStaticHrefOne = quickStaticHref[0];
      const quickStaticHrefTwo = quickReorderQuantity;
      const quickDynamicHref = quickStaticHrefOne + ':'.concat(quickStaticHrefTwo);

      quickStaticItem.setAttribute('href', quickDynamicHref);
      quantityaddtocart.setAttribute('data-quantity', quickReorderQuantity);
    }
  }
};

const reorderCartHandler = (event) => {
  const {
    frequency,
    id,
    snsId,
    unitType,
    quantity,
  } = event.target.dataset;

  if (snsId != '') {
    addItemToCart(id, quantity, frequency, unitType, snsId, id, '', 'cart');
  } else {
    quickOrdertoCart(id, quantity);
  }
};

const reorderCheckoutHandler = (event) => {
  const {
    frequency,
    id,
    snsId,
    unitType,
    quantity,
  } = event.target.dataset;

  localStorage.setItem('recharge-checkout-pressed', 'true');
  localStorage.setItem('recharge-just-logged-in', 'true');
  addItemToCart(id, quantity, frequency, unitType, snsId, id, '', 'cart');
};

const orderAllAgainHandler = (event) => {
  const variants = event.target.getAttribute('data-variant');
  const variantList = variants.split(',');

  variantList.pop();
  orderAllToCart(variantList);
};

const clickHandler = (event) => {
  const {
    classList,
    id,
  } = event.target;
  const {
    body,
  } = document;
  const redeemLoginData = document.getElementById('redeem_login');
  const redeemEnrollmentData = document.getElementById('redeem_enrollment');

  if (classList.contains('shop_login') || classList.contains('shop_joinnow')) {
    if (body.classList.contains('recharge-product')) {
      body.classList.remove('recharge-product');
    }


    localStorage.setItem('redeem_login', 'yes');
    redeemLoginData.value = 'yes';
    redeemEnrollmentData.value = 'yes';
  }

  if (classList.contains('checkout-button')) {
    if (body.classList.contains('recharge-product')) {
      body.classList.remove('recharge-product');
    }

    localStorage.setItem('redeem_login', 'no');
    redeemLoginData.value = 'no';
    redeemEnrollmentData.value = 'no';
  }

  if (id === 'signin-google-link' || id === 'signup-google-link') {
    if (typeof dataLayerTrigger === 'function' && typeof customCart !== 'undefined') {
      dataLayerTriggerLogin('google');
    }
  }

  if (id === 'signup-fb-link' || id === 'signin-fb-link') {
    if (typeof dataLayerTrigger === 'function' && typeof customCart !== 'undefined') {
      dataLayerTriggerLogin('facebook');
    }
  }
};

const closeNotification = () => {
  document.cookie = 'mtracker=bannerDismissed; path=/';

  const notificationBar = document.querySelector('.notification-bar');

  notificationBar.style.transition = '0.8s';
  notificationBar.style.opacity = 0;
};

const addClassToBody = () => {
  document.body.classList.add('login-header');
};

const initializeReorder = () => {
  const quantityIncreaseButtons = document.querySelectorAll('.quick-reorder-product-popup-quantity .incr-btn');

  quantityIncreaseButtons.forEach((quantityIncreaseButton) => {
    quantityIncreaseButton.addEventListener('click', quantityHandler);
  });

  const quickReorderButtons = document.querySelectorAll('.quick-reorder__product-order .quick-reorder-button');

  quickReorderButtons.forEach((quickReorderButton) => {
    quickReorderButton.addEventListener('click', reorderCartHandler);
  });

  const quickReorderCheckoutButtons = document.querySelectorAll('.quick-reorder-checkout-button');

  quickReorderCheckoutButtons.forEach((quickReorderCheckoutButton) => {
    quickReorderCheckoutButton.addEventListener('click', reorderCheckoutHandler);
  });

  const orderAllAgain = document.querySelectorAll('.order-all-again');

  orderAllAgain.forEach((orderAgain) => {
    orderAgain.addEventListener('click', orderAllAgainHandler);
  });
};

const notificationHandler = () => {
  const notificationCloseButton = document.querySelector('.notification-close');

  if (notificationCloseButton) notificationCloseButton.addEventListener('click', closeNotification);
};

const shelfLifeHandler = () => {
  setTimeout(() => {
    if (document.querySelector('.limespot-recommendation-box-carousel-shelf')) {
      document.querySelector('.limespot-recommendation-box-carousel-shelf').style.width = '100%';
    }
  }, 2000);
};

const userAgentHandler = () => {
  const ua = navigator.userAgent.toLowerCase();
  const isAndroid = ua.indexOf('android') > -1;

  if (isAndroid) {
    document.body.classList.add('enfa-android-device');
  }
};

const loginButtonHandler = () => {
  const loginButtons = document.querySelectorAll('.cart-page-header-link.login, .site-link.shop_login.login-popup, .login.shop_login');

  loginButtons.forEach((loginbutton) => {
    loginbutton.addEventListener('click', addClassToBody);
  });
};

const loadAccountInformations = () => {
  initializeReorder();
  notificationHandler();
  shelfLifeHandler();
  userAgentHandler();
  loginButtonHandler();
};

document.addEventListener('DOMContentLoaded', loadAccountInformations);
document.addEventListener('click', clickHandler);


$(document).ready(e=>{
  const desk_menu = document.querySelectorAll(".expanded.drop-down");
  const reorder_btns = document.querySelectorAll(".quick-reorder__product-order .button");
  const add_address = document.querySelectorAll(".addresslisting .btn-add-address");
  const edit_address = document.querySelectorAll(".address-btns .primary-button");


  Object.keys(add_address).forEach(index => {
    if(!isNaN(index)){
      const btn = add_address[index];
      btn.addEventListener('click', e=> {
        removeSelectedOptions(true);
      });
    }
  });

})

const removeSelectedOptions = (addedAddress = false, form = null) => {
  const field = addedAddress ? 'address-new-form' : `edit-address form#address_form_${form}`;
  sortOptions(document.querySelector(`.${field} select[name='address[province]']`).options);
  var idsRemove = ['American Samoa','Guam','Marshall Islands','Northern Mariana Islands','Palau','Puerto Rico','Virgin Islands','Armed Forces Americas','Armed Forces Europe','Armed Forces Pacific','Federated States of Micronesia'];
  idsRemove.forEach((id) => {
    var node = document.querySelector(`.${field} select[name='address[province]'] > option[value='${id}']`);
    node.parentNode.removeChild(node);
  })
}

function sortOptions(options) {
  var optionsArray = [];
  for (var i = 0; i < options.length; i++) {
      optionsArray.push(options[i]);
  }
  optionsArray = optionsArray.sort(function (a, b) {     
      return a.innerHTML.toLowerCase().charCodeAt(0) - b.innerHTML.toLowerCase().charCodeAt(0);    
  });
  for (var i = 0; i <= options.length; i++) { 
    options[i] = optionsArray[i];
  }
  options[57] = optionsArray[58]
  options[58] = optionsArray[57]
}

const onClickReorderCheckout = (id,sku,order, limit) => {
  const quantity = +document.querySelector(`#qtyLimit${sku}${order}`).value;
  fetch('/cart.js')
  .then(response => response.json())
  .then(async(data) => {
    let limitProduct = 10 
    const existInTheCart = data.items.find((i) => id == i.id)
    const finderQuantity = limit.find((i) => i.includes("MAXQTY"))
    if(finderQuantity){
      const limitQuantity = +finderQuantity?.split("|")[1]?.split('-')[1];
      limitProduct = limitQuantity
    }
    if(existInTheCart){
      data.items.map((i) => {
        if(i.id === existInTheCart.id){
          if(i.quantity + quantity > limitProduct){
            i.quantity = limitProduct
          }else{
            i.quantity = i.quantity + quantity;
          }
        }
      })
      fetch('/cart/clear.json',{
        method: 'POST',
        headers: {
            "Accept": "application/json"
        }
      }).then(() => {
          fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items : data.items
            })
          }).then(() => {
            document.location.href = '/cart/checkout';
          }).catch((e) => {
            console.log(e)
          })

      }).catch((e) => {
        console.log(e)
      })
    } else {
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          id,
          quantity
        })
      }).then(() => {
        document.location.href = '/cart/checkout';
      }).catch((e) => {
        console.log(e)
      })
    }
  }).catch((e) => {
    console.log(e)
  });

}